import dynamic from 'next/dynamic';

import type { MapWrapperProps } from './map-wrapper';

// maplibre is ~700 KB of JavaScript. Every app imports this library through its barrel, so a
// static MapWrapper here put maplibre in the employer app's shared `_app` chunk, downloaded by
// every page including the first step of /getting-started (RW-235, item 4). Through the barrel
// the map now arrives in its own chunk: still rendered on the server, and preloaded before
// hydration on pages that render it there.
//
// A page that needs the map ref the moment it mounts can import the eager implementation
// from `@restworld/ui-components/map-wrapper` instead.
export const MapWrapper = dynamic<MapWrapperProps>(() => import('./map-wrapper').then((mod) => mod.MapWrapper));
export default MapWrapper;

export type { MapWrapperProps } from './map-wrapper';
export { DEFAULT_MAP_STYLE, MapScriptLoadingUI } from './map-wrapper.shared';
